import { render, staticRenderFns } from "./PartnerClasses.vue?vue&type=template&id=c889ac06&scoped=true"
import script from "./PartnerClasses.vue?vue&type=script&lang=js"
export * from "./PartnerClasses.vue?vue&type=script&lang=js"
import style0 from "./PartnerClasses.vue?vue&type=style&index=0&id=c889ac06&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c889ac06",
  null
  
)

export default component.exports